import { render, staticRenderFns } from "./TeacherDepart.vue?vue&type=template&id=752511d0"
import script from "./TeacherDepart.vue?vue&type=script&lang=js"
export * from "./TeacherDepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports